export default __webpack_public_path__ + "static/media/GarbageDelte.9de469ed.svg";